import { render, staticRenderFns } from "./DurationField.vue?vue&type=template&id=7012bfe7&"
import script from "./DurationField.vue?vue&type=script&lang=js&"
export * from "./DurationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QTooltip}, component.options.components || {})
